import React from 'react';
import {SvgIcon} from '@mui/material';
import type {IconProps} from './types';

export const PrizeIcon: React.FC<IconProps> = (props: IconProps) => {
  return (
    // Scale down icon by changing viewbox from 16x16 to 24x24 with 4px padding left and right and 8px bottom padding for better alignment
    <SvgIcon {...props} viewBox="-4 0 24 20">
      <path d="M7 8.48001V14.48H9V8.48001H7Z" />
      <path d="M12 14H4C3.44772 14 3 14.4477 3 15C3 15.5523 3.44772 16 4 16H12C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14Z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.878679 0.878679C0.31607 1.44129 0 2.20435 0 3C0 3.79565 0.31607 4.55871 0.878679 5.12132C1.44129 5.68393 2.70435 6 3.5 6L3 0C2.20435 0 1.44129 0.316071 0.878679 0.878679ZM2.29289 2.29289C2.10536 2.48043 2 2.73478 2 3C2 3.26522 2.10536 3.51957 2.29289 3.70711C2.48043 3.89464 2.73478 4 3 4V2C2.73478 2 2.48043 2.10536 2.29289 2.29289Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 4.5V0H3V4.5C3 5.69347 3.52678 6.83807 4.46447 7.68198C5.40215 8.52589 6.67392 9 8 9C9.32608 9 10.5979 8.52589 11.5355 7.68198C12.4732 6.83807 13 5.69347 13 4.5ZM11 4.5V2H5V4.5C5 5.16304 5.31607 5.79893 5.87868 6.26777C6.44129 6.73661 7.20435 7 8 7C8.79565 7 9.55871 6.73661 10.1213 6.26777C10.6839 5.79893 11 5.16304 11 4.5Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1213 0.878679C15.6839 1.44129 16 2.20435 16 3C16 3.79565 15.6839 4.55871 15.1213 5.12132C14.5587 5.68393 13.2956 6 12.5 6L13 0C13.7956 0 14.5587 0.31607 15.1213 0.878679ZM13.7071 2.29289C13.8946 2.48043 14 2.73478 14 3C14 3.26522 13.8946 3.51957 13.7071 3.70711C13.5196 3.89464 13.2652 4 13 4V2C13.2652 2 13.5196 2.10536 13.7071 2.29289Z"
      />
    </SvgIcon>
  );
};
